"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const PreferencesHeader_1 = __importDefault(require("../header/PreferencesHeader"));
const SpectraPanelHeader_1 = __importDefault(require("./SpectraPanelHeader"));
const SpectraPreferences_1 = __importDefault(require("./SpectraPreferences"));
const SpectrumsTabs_1 = __importDefault(require("./SpectrumsTabs"));
const styles = {
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
};
function SpectrumListPanel() {
    const settingsRef = (0, react_1.useRef)();
    const [isFlipped, setFlipStatus] = (0, react_1.useState)(false);
    function settingsPanelHandler() {
        setFlipStatus(!isFlipped);
    }
    function saveSettingHandler() {
        settingsRef.current.saveSetting();
        setFlipStatus(!isFlipped);
    }
    return ((0, jsx_runtime_1.jsx)("div", { style: styles, children: isFlipped ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(PreferencesHeader_1.default, { onSave: saveSettingHandler, onClose: settingsPanelHandler }), (0, jsx_runtime_1.jsx)(SpectraPreferences_1.default, { ref: settingsRef })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SpectraPanelHeader_1.default, { onSettingClick: settingsPanelHandler }), (0, jsx_runtime_1.jsx)(SpectrumsTabs_1.default, {})] })) }));
}
exports.default = (0, react_1.memo)(SpectrumListPanel);
